import { Injectable } from "@angular/core";
import { CanLoad, CanMatch, GuardResult, MaybeAsync, Route, Router, UrlSegment } from "@angular/router";
import { UserService } from "../api/service/user-service";


@Injectable({
    providedIn: 'root'
})
export class LoginGuard implements CanMatch {

    constructor(private userService: UserService, private router: Router) {}

    canMatch(route: Route, segments: UrlSegment[]): MaybeAsync<GuardResult> {
        
        if (this.userService.isAuthenticated()) {
            //this.router.navigateByUrl('dashboard')
            return true;
        }

        return true;
    }
    
}